"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
require("./styles.scss");
/**
 * @param {{
 *     url: string;
 * }} props
 */
function SecurityRequirementAlert(_ref) {
  var url = _ref.url;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "SecurityRequirementAlert"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "SecurityRequirementAlert-icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faExclamationTriangle"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "SecurityRequirementAlert-message"
  }, /*#__PURE__*/_react["default"].createElement("p", null, "Por motivos de seguran\xE7a e pol\xEDticas de seguran\xE7a, seu login ou autentica\xE7\xE3o \xE9 monitorado."), /*#__PURE__*/_react["default"].createElement("p", null, "Para realizar o login, voc\xEA deve instalar o DokDrive vers\xE3o 2.0.44 ou acima, clique ", /*#__PURE__*/_react["default"].createElement("a", {
    href: url
  }, "aqui"), "."), /*#__PURE__*/_react["default"].createElement("p", null, "Ap\xF3s a instala\xE7\xE3o, abra o DokDrive e tente novamente.")));
}
var _default = SecurityRequirementAlert;
exports["default"] = _default;